module.exports = new __parcel__URL__("0s.a30fcd21.png").toString();